import fetch from 'cross-fetch';

import { createBaseApi, getAuthHeaders } from '../utils/baseApi';

const apiVersion = 'v1';

const { getJson, postJson, deleteJson, putJson } = createBaseApi(`/api/${apiVersion}`, { headers: getAuthHeaders });

// use fetch to avoid 403 toast on agent portal page
export const getInsuranceRequest = insuranceRequestId => fetch(
  `/api/${apiVersion}/insurance-requests/${insuranceRequestId}/`,
  {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json; text/plain; text/xml',
      // Resolved at call time, not at module-import time — a token written
      // after boot (eg by the verify/OTP flow, which navigates via
      // history.push rather than a full reload) must be picked up on the
      // very next request (DEV-3087).
      ...getAuthHeaders()
    }
  }
).then(async response => response.json());

export const addAgentToInsured = insuranceRequestId => postJson(`insurance-requests/${insuranceRequestId}/insureds`);

export const getInsuranceRequestInsured = insuranceRequestId => getJson(`insurance-requests/${insuranceRequestId}/insureds`);

export const getInsuranceRequestAgencies = (insuranceRequestId, pageData) => getJson(`insurance-requests/${insuranceRequestId}/agencies`, pageData);

export const createAgency = (insuranceRequestId, data) => postJson(`insurance-requests/${insuranceRequestId}/agencies`, {
  address_1: data?.address,
  city: data?.city,
  country: data?.country,
  google_place_id: data?.googlePlaceId,
  license: data?.license,
  name: data?.name,
  state: data?.state,
  zip: data?.zip
});

export const updateAgency = (insuranceRequestId, data) => putJson(`insurance-requests/${insuranceRequestId}/agencies`, {
  agency_id: data.agencyId,
  name: data?.name,
  address_1: data?.address,
  city: data?.city,
  state: data?.state,
  zip: data?.zip,
  country: data?.country,
  google_place_id: data?.googlePlaceId,
  license: data?.license
});

export const updateAgentDetails = (insuranceRequestId, data) => putJson(`insurance-requests/${insuranceRequestId}/agents`, {
  user_first_name: data?.first,
  user_last_name: data?.last,
  user_phone: data?.phone
});
